export var UniversNetworkLinkRead;
(function (UniversNetworkLinkRead) {
    let type;
    (function (type) {
        type["OWN"] = "own";
        type["COMPETITOR"] = "competitor";
        type["ATTRACTOR"] = "attractor";
        type["INFO"] = "info";
    })(type = UniversNetworkLinkRead.type || (UniversNetworkLinkRead.type = {}));
})(UniversNetworkLinkRead || (UniversNetworkLinkRead = {}));
